/* Generated from Java with JSweet 2.3.7 - http://www.jsweet.org */
import { IDefinition } from '../../../core/models/common/IDefinition';
import { IVisitor } from '../../../core/visitors/IVisitor';
import { IOas20Visitor } from '../visitors/IOas20Visitor';
import { Oas20Parameter } from './Oas20Parameter';

/**
 * Constructor.
 * @param {string} name
 * @class
 * @extends Oas20Parameter
 * @author eric.wittmann@gmail.com
 */
export class Oas20ParameterDefinition extends Oas20Parameter implements IDefinition {
    /*private*/ _name : string;

    public constructor(name : string) {
        super();
        if(this._name===undefined) this._name = null;
        this._name = name;
    }

    /**
     * @see io.apicurio.datamodels.core.models.common.INamed#getName()
     * @return {string}
     */
    public getName() : string {
        return this._name;
    }

    /**
     * @see io.apicurio.datamodels.core.models.common.INamed#rename(java.lang.String)
     * @param {string} newName
     */
    public rename(newName : string) {
        this._name = newName;
    }

    /**
     * @see io.apicurio.datamodels.core.models.common.Parameter#accept(io.apicurio.datamodels.core.visitors.IVisitor)
     * @param {*} visitor
     */
    public accept(visitor : IVisitor) {
        let viz : IOas20Visitor = <IOas20Visitor><any>visitor;
        viz.visitParameterDefinition(this);
    }
}
Oas20ParameterDefinition["__class"] = "io.apicurio.datamodels.openapi.v2.models.Oas20ParameterDefinition";
Oas20ParameterDefinition["__interfaces"] = ["io.apicurio.datamodels.core.models.common.IDefinition","io.apicurio.datamodels.core.models.IVisitable","io.apicurio.datamodels.core.models.IReferenceNode","io.apicurio.datamodels.core.models.common.INamed"];




